import React from 'react'
import MonthlyPerfData from './MonthlyPerfData'
import * as ScreenPermissions from 'core/EventActions'
import { hasAccesPermits } from 'core/utils'
import { Route } from 'react-router-dom'

export const MonthlyPerformanceDataContainer = ({
  actionPermits,
  envConfig,
}) => {
  return hasAccesPermits({
    authGodMode: envConfig.authGodMode,
    actionPermits,
    eventActions: [
      ScreenPermissions.MONTHLY_PERF_DATA,
      ScreenPermissions.MONTHLY_PERF_DATA_ADMIN,
    ],
    matchAny: true,
  }) ? (
    [
      <Route
        key="monthlypefdata"
        exact
        path="/monthlypefdata"
        component={MonthlyPerfData}
      />,
    ]
  ) : (
    <React.Fragment />
  )
}
